import { DOC_TYPE as DOC_TYPE_ORG } from 'entities/Documents'
import { ValueOf, ArrayElement, InvertObject } from 'types'
import { invertKeyValue } from 'utils/utils'

export const SERVER = '/api/v1/'
export const API_BASE = '/api/v1/'
export const MANAGEMENT_API_BASE = '/api/management/v1/'
export const AUTH_API_BASE = '/api/auth/v1/'
export const OCR_ICON = 'static/icon_OCR_wh.png'
export const OCR_ICON_ALT = 'ocr icon'
export const OCR_LOGO = 'static/OCR_2_wh.png'
export const OCR_LOGO_ALT = 'ocr logo'
export const MODE = {
  NORMAL: 'normal',
  VERIFY: 'verify',
} as const
export const STATUS_CODE = {
  新規登録: 0,
  編集済み: 1,
  出力済み: 2,
  削除: 3,
  'チェック中(1/2)': 4,
  'チェック中(1/3)': 5,
  'チェック中(2/3)': 6,
  確認待ち: 7,
  出力待ち: 8,
  送信エラー: 9,
} as const
export const STATUS_LIST = invertKeyValue(STATUS_CODE) as Readonly<
  InvertObject<typeof STATUS_CODE>
>
export const NEW_STATUS_NO = 0
export const EDITED_STATUS_NO = 1
export const SENT_STATUS_NO = 2
export const DELETED_STATUS_NO = 3
export const CHECKING_1_2_STATUS_NO = 4
export const CHECKING_1_3_STATUS_NO = 5
export const CHECKING_2_3_STATUS_NO = 6
export const VERIFY_STATUS_NO = 7
export const CONFIRMED_STATUS_NO = 8
export const SEND_ERROR_STATUS_NO = 9
export type StatusNo =
  | typeof NEW_STATUS_NO
  | typeof EDITED_STATUS_NO
  | typeof SENT_STATUS_NO
  | typeof DELETED_STATUS_NO
  | typeof SEND_ERROR_STATUS_NO
  | typeof CHECKING_1_2_STATUS_NO
  | typeof CHECKING_1_3_STATUS_NO
  | typeof CHECKING_2_3_STATUS_NO
  | typeof VERIFY_STATUS_NO
  | typeof CONFIRMED_STATUS_NO

export const IMG_EXT_LIST = ['png', 'PNG', 'jpeg', 'JPEG'] as const

// TODO: remove me
export const DOC_TYPE = DOC_TYPE_ORG
export type DocType = ValueOf<typeof DOC_TYPE>
export const BUILTIN_DOC_TYPES = [
  DOC_TYPE.INVOICE,
  DOC_TYPE.ORDER_FORM,
  DOC_TYPE.RECEIPT,
  DOC_TYPE.GENERAL_OCR,
] as const

export const REPORT_TYPE = {
  SPECIFIC: '特定帳票',
  TEMPLATE: '定形帳票',
}

export const IMPORT_TYPE_OPTIONS = [
  {
    value: 'multi x multi',
    label: '１ページを１帳票として取り込む',
  },
  {
    value: 'single x multi',
    label: '１ファイルに１帳票として取り込む',
  },
] as const

export const ERROR_TEXT = {
  required: '必須入力項目です',
  maxLength: '$0文字以内で入力してください',
  noMatchedVendor: '取引先情報が存在しません',
  noMatchedCompanyId: 'フォーマットが無効です（T+13桁数字）',
  httpUrlFormat: '有効なURLを入力してください',
  blank: '必須入力項目です',
  dateFormat: '日付が無効です',
  csvDownloadFailedTitle: 'CSV出力エラー',
  csvDownloadFailed:
    '文書名の文字数が長い場合は、文字数を短くして再度お試しください',
  csvSelectZero: '出力項目を選択してください',
  reOccured: '処理中に予期しないエラーが発生しました',
} as const

export const MAX_UPLOAD_FILES = 100
export const MOBILE_MAX_UPLOAD_FILES = 30

export const CONFIDENCE_COLOR = {
  mid: 'rgb(237, 207, 105)',
  low: 'rgb(235, 127, 92)',
} as const

export const REDIRECT_URLS = {
  LOGIN: '/auth/login',
  LOGIN_FAILURE: '/auth/login/failure',
  HOME: '/',
}

export const ACCEPT_FILE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/tiff',
  'application/pdf',
  '.zip',
] as const
export const FILE_EXT = {
  PNG: 'png',
  JPG: 'jpg',
  JPEG: 'jpeg',
  PDF: 'pdf',
  TIF: 'tif',
  TIFF: 'tiff',
  ZIP: 'zip',
} as const
export const ACCEPT_FILE_EXT = [
  FILE_EXT.PNG,
  FILE_EXT.JPG,
  FILE_EXT.JPEG,
  FILE_EXT.PDF,
  FILE_EXT.TIF,
  FILE_EXT.TIFF,
  FILE_EXT.ZIP,
] as const

// used by ocr builder setting where tiff is not used
export const ACCEPT_FILE_EXT_IMG_ONLY = [
  FILE_EXT.PNG,
  FILE_EXT.JPG,
  FILE_EXT.JPEG,
] as const
export const MAX_FILENAME_LENGTH = 100
export const FILE_SIZE_LIMIT_20 = 20
export const FILE_SIZE_LIMIT_100 = 100
export const FILE_SIZE_LIMIT_500 = 500

export const FILE_SIZE_LIMITS: { [key: string]: number } = {
  [FILE_EXT.PNG]: FILE_SIZE_LIMIT_20,
  [FILE_EXT.JPG]: FILE_SIZE_LIMIT_20,
  [FILE_EXT.JPEG]: FILE_SIZE_LIMIT_20,
  [FILE_EXT.PDF]: FILE_SIZE_LIMIT_100,
  [FILE_EXT.TIF]: FILE_SIZE_LIMIT_100,
  [FILE_EXT.TIFF]: FILE_SIZE_LIMIT_100,
  [FILE_EXT.ZIP]: FILE_SIZE_LIMIT_500,
}

export const FILENAME_LENGTH_ERROR_MSG =
  'ファイル名が長すぎます。100文字未満で指定してください'
export const FILE_EXT_ERROR_MSG =
  'ファイル形式がサポートされていません 対応形式：PDF / JPEG / PNG / TIFF'
export const IMG_FILE_EXT_ERROR_MSG =
  'ファイル形式がサポートされていません 対応形式：JPEG / PNG'
const PNG_JPG_TIFF_FILE_SIZE_ERROR =
  'JPEG / PNGファイルのアップロードサイズ(20MB)の上限を超えています'
const PDF_TIFF_FILE_SIZE_ERROR =
  'PDF / TIFFファイルのアップロードサイズ(100MB)の上限を超えています'
const ZIP_FILE_SIZE_ERROR =
  'ZIPファイルのアップロードサイズ(500MB)の上限を超えています'
export const FILE_SIZE_ERROR_IMG_EXT_ONLY =
  'アップロードサイズ(20MB)の上限を超えています'

export const FILE_SIZE_ERROR_MESSAGES: { [key: string]: string } = {
  [FILE_EXT.PNG]: PNG_JPG_TIFF_FILE_SIZE_ERROR,
  [FILE_EXT.JPG]: PNG_JPG_TIFF_FILE_SIZE_ERROR,
  [FILE_EXT.JPEG]: PNG_JPG_TIFF_FILE_SIZE_ERROR,
  [FILE_EXT.PDF]: PDF_TIFF_FILE_SIZE_ERROR,
  [FILE_EXT.TIF]: PDF_TIFF_FILE_SIZE_ERROR,
  [FILE_EXT.TIFF]: PDF_TIFF_FILE_SIZE_ERROR,
  [FILE_EXT.ZIP]: ZIP_FILE_SIZE_ERROR,
}

export const AUTHORITIES = {
  ADMIN: 'admin',
  REGISTER: 'register',
  OPERATOR: 'operator',
  MANAGER: 'manager',
} as const

export const ORDERED_AUTHORITIES = [
  AUTHORITIES.REGISTER,
  AUTHORITIES.OPERATOR,
  AUTHORITIES.MANAGER,
  AUTHORITIES.ADMIN,
] as const
export type Authority = ArrayElement<typeof ORDERED_AUTHORITIES>

export const AUTHORITIES_JP = {
  [AUTHORITIES.ADMIN]: 'システム管理者',
  [AUTHORITIES.REGISTER]: '一般ユーザー',
  [AUTHORITIES.OPERATOR]: '登録担当者',
  [AUTHORITIES.MANAGER]: '運用管理者',
} as const
export const AUTHORITIES_FROM_JP = invertKeyValue(AUTHORITIES_JP) as Readonly<
  InvertObject<typeof AUTHORITIES_JP>
>

export const OPERATION_FLOW_TYPES = {
  normal: '通常フロー',
  doubleCheckVerify: 'ダブルチェック＆ベリファイ',
  tripleCheckVerify: 'トリプルチェック＆ベリファイ',
}

export const SNACKBAR_DURATION = 10 * 1000
export const MAX_MUTLTI_EDIT_DOCS = 100
export const EXPENSE_TYPE_WIDTH = 280

export const VITE_BASE_DOC_URL = import.meta.env.VITE_BASE_DOC_URL
export const LINK_TERMSOFUSE =
  'https://line-works.com/ai-product/terms/ocrreader_termsofuse/'

export const LINK_SUPPORT =
  'https://line-works.com/contactus/ai-product/technical-support/'

export const DEFAULT_PER_PAGE = 10

export enum FIELD_TYPE {
  NORMAL = 'NORMAL',
  MULTI_BOX = 'MULTI_BOX',
  CHECKBOX = 'CHECKBOX',
}

export const DELIM = ':'

export const sidebarWidth = 240

export const LOCAL_STORAGE_KEYS = {
  documentListPerPage: 'documentListPerPage',
  viewerScale: 'viewerScale',
}

export const NOT_FOUND_INDEX = -1

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
}
